import http from "../http-common";
import authHeader from "./authHeader";
import { REMARK_API } from "../api";

const getAllRemark = () => {
  return http.get(`${REMARK_API}`);
};
//TODO: in BE
const getAllRemarkOfEmployee = (id) => {
  return http.get(`${REMARK_API}/emp/${id}`, { headers: authHeader() });
};
const getAllRemarkOfCustomer = (id) => {
  return http.get(`${REMARK_API}/customer/${id}`, { headers: authHeader() });
};

const createRemark = (data) => {
  return http.post(`${REMARK_API}`, data, { headers: authHeader() });
};

const RemarkService = {
  getAllRemark,
  getAllRemarkOfEmployee,
  createRemark,
  getAllRemarkOfCustomer,
};

export default RemarkService;
